import { useMemo } from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { useStackStyles } from './Stack.styles';
import { IStackProps } from './Stack.types';

const Stack = (props: IStackProps) => {
    const { id, horizontal, aligned, spaced, reversed, style, className, children } = props;

    const styles = useStackStyles();
    const classes = useMemo(() => {
        let layoutStyle;
        if (horizontal) {
            layoutStyle = reversed ? styles.horizontalReverse : styles.horizontal;
        } else {
            layoutStyle = reversed ? styles.verticalReverse : styles.vertical;
        }

        return {
            layoutStyle,
            alignmentStyle: aligned ? styles.aligned : styles.centerAligned,
            spacedStyle: spaced ? styles.spaced : styles.centered
        };
    }, [horizontal, reversed, aligned, spaced]);

    const mergedClasses = mergeClasses(
        styles.root,
        classes.layoutStyle,
        classes.alignmentStyle,
        classes.spacedStyle
    );

    return (
        <div id={id} style={style} className={mergeClasses(mergedClasses, className)}>
            {children}
        </div>
    );
};

export default Stack;
